"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var lodash_1 = require("lodash");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var logs_1 = require("@ledgerhq/logs");
var xpub_1 = __importDefault(require("./xpub"));
var explorer_1 = __importDefault(require("./explorer"));
var storage_1 = __importDefault(require("./storage"));
var utils = __importStar(require("./utils"));
var factory_1 = __importDefault(require("./crypto/factory"));
var BitcoinLikeWallet = /** @class */ (function () {
    function BitcoinLikeWallet() {
        this.explorerInstances = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.explorers = {
            ledgerv3: function (explorerURI) {
                return new explorer_1["default"]({
                    explorerURI: explorerURI,
                    explorerVersion: "v3"
                });
            },
            ledgerv2: function (explorerURI) {
                return new explorer_1["default"]({
                    explorerURI: explorerURI,
                    explorerVersion: "v2"
                });
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.accountStorages = {
            mock: function () { return new storage_1["default"](); }
        };
    }
    BitcoinLikeWallet.prototype.getExplorer = function (explorer, explorerURI) {
        var id = "explorer-".concat(explorer, "-uri-").concat(explorerURI);
        this.explorerInstances[id] =
            this.explorerInstances[id] || this.explorers[explorer](explorerURI);
        return this.explorerInstances[id];
    };
    BitcoinLikeWallet.prototype.generateAccount = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var crypto, storage, explorer;
            var _a;
            return __generator(this, function (_b) {
                crypto = (0, factory_1["default"])(params.currency);
                storage = (_a = this.accountStorages)[params.storage].apply(_a, __spreadArray([], __read(params.storageParams), false));
                explorer = this.getExplorer(params.explorer, params.explorerURI);
                return [2 /*return*/, {
                        params: params,
                        xpub: new xpub_1["default"]({
                            storage: storage,
                            explorer: explorer,
                            crypto: crypto,
                            xpub: params.xpub,
                            derivationMode: params.derivationMode
                        })
                    }];
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.syncAccount = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, account.xpub.sync()];
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.getAccountNewReceiveAddress = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, account.xpub.getNewAddress(0, 1)];
                    case 1:
                        address = _a.sent();
                        return [2 /*return*/, address];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.getAccountNewChangeAddress = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, account.xpub.getNewAddress(1, 1)];
                    case 1:
                        address = _a.sent();
                        return [2 /*return*/, address];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.getAccountTransactions = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var txs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, account.xpub.storage["export"]()];
                    case 1:
                        txs = _a.sent();
                        return [2 /*return*/, txs];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.getAccountUnspentUtxos = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var addresses, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, account.xpub.getXpubAddresses()];
                    case 1:
                        addresses = _b.sent();
                        _a = lodash_1.flatten;
                        return [4 /*yield*/, Promise.all(addresses.map(function (address) {
                                return account.xpub.storage.getAddressUnspentUtxos(address);
                            }))];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.estimateAccountMaxSpendable = function (account, feePerByte, excludeUTXOs, pickUnconfirmedRBF, outputAddresses) {
        if (outputAddresses === void 0) { outputAddresses = []; }
        return __awaiter(this, void 0, void 0, function () {
            var addresses, utxos, _a, balance, usableUtxoCount, fees, maxSpendable;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, account.xpub.getXpubAddresses()];
                    case 1:
                        addresses = _b.sent();
                        _a = lodash_1.flatten;
                        return [4 /*yield*/, Promise.all(addresses.map(function (address) {
                                return account.xpub.storage.getAddressUnspentUtxos(address);
                            }))];
                    case 2:
                        utxos = _a.apply(void 0, [_b.sent()]);
                        balance = new bignumber_js_1["default"](0);
                        (0, logs_1.log)("btcwallet", "estimateAccountMaxSpendable utxos", utxos);
                        usableUtxoCount = 0;
                        utxos.forEach(function (utxo) {
                            if (!excludeUTXOs.find(function (excludeUtxo) {
                                return excludeUtxo.hash === utxo.output_hash &&
                                    excludeUtxo.outputIndex === utxo.output_index;
                            })) {
                                if ((pickUnconfirmedRBF && utxo.rbf) || utxo.block_height !== null) {
                                    usableUtxoCount++;
                                    balance = balance.plus(utxo.value);
                                }
                            }
                        });
                        fees = feePerByte *
                            utils.maxTxSizeCeil(usableUtxoCount, outputAddresses, outputAddresses.length == 0, account.xpub.crypto, account.xpub.derivationMode);
                        (0, logs_1.log)("btcwallet", "estimateAccountMaxSpendable balance", balance);
                        (0, logs_1.log)("btcwallet", "estimateAccountMaxSpendable fees", fees);
                        maxSpendable = balance.minus(fees);
                        return [2 /*return*/, maxSpendable.lt(0) ? new bignumber_js_1["default"](0) : maxSpendable];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.getAccountBalance = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var balance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, account.xpub.getXpubBalance()];
                    case 1:
                        balance = _a.sent();
                        return [2 /*return*/, balance];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.getAccountPendings = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var addresses, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, account.xpub.getXpubAddresses()];
                    case 1:
                        addresses = _b.sent();
                        _a = lodash_1.flatten;
                        return [4 /*yield*/, Promise.all(addresses.map(function (address) { return account.xpub.explorer.getPendings(address); }))];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.buildAccountTx = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var changeAddress, txInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, params.fromAccount.xpub.getNewAddress(1, 1)];
                    case 1:
                        changeAddress = _a.sent();
                        return [4 /*yield*/, params.fromAccount.xpub.buildTx({
                                destAddress: params.dest,
                                amount: params.amount,
                                feePerByte: params.feePerByte,
                                changeAddress: changeAddress,
                                utxoPickingStrategy: params.utxoPickingStrategy,
                                sequence: params.sequence
                            })];
                    case 2:
                        txInfo = _a.sent();
                        return [2 /*return*/, txInfo];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.signAccountTx = function (params) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var btc, fromAccount, txInfo, initialTimestamp, additionals, hasExtraData, onDeviceSignatureRequested, onDeviceSignatureGranted, onDeviceStreaming, hasTimestamp, length, buffer, bufferOffset, outputScriptHex, associatedKeysets, inputs, lastOutputIndex, tx;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        btc = params.btc, fromAccount = params.fromAccount, txInfo = params.txInfo, initialTimestamp = params.initialTimestamp, additionals = params.additionals, hasExtraData = params.hasExtraData, onDeviceSignatureRequested = params.onDeviceSignatureRequested, onDeviceSignatureGranted = params.onDeviceSignatureGranted, onDeviceStreaming = params.onDeviceStreaming;
                        hasTimestamp = params.hasTimestamp;
                        length = txInfo.outputs.reduce(function (sum, output) {
                            return sum + 8 + output.script.length + 1;
                        }, 1);
                        // refer to https://github.com/LedgerHQ/lib-ledger-core/blob/fc9d762b83fc2b269d072b662065747a64ab2816/core/src/wallet/bitcoin/api_impl/BitcoinLikeTransactionApi.cpp#L478
                        // Decred has a witness and an expiry height
                        if (additionals && additionals.includes("decred")) {
                            length += 2 * txInfo.outputs.length;
                        }
                        buffer = Buffer.allocUnsafe(length);
                        bufferOffset = 0;
                        bufferOffset = utils.writeVarInt(buffer, txInfo.outputs.length, bufferOffset);
                        txInfo.outputs.forEach(function (txOut) {
                            // refer to https://github.com/bitcoinjs/bitcoinjs-lib/blob/59b21162a2c4645c64271ca004c7a3755a3d72fb/ts_src/bufferutils.ts#L26
                            buffer.writeUInt32LE(txOut.value.modulo(new bignumber_js_1["default"](0x100000000)).toNumber(), bufferOffset);
                            buffer.writeUInt32LE(txOut.value.dividedToIntegerBy(new bignumber_js_1["default"](0x100000000)).toNumber(), bufferOffset + 4);
                            bufferOffset += 8;
                            if (additionals && additionals.includes("decred")) {
                                bufferOffset = utils.writeVarInt(buffer, 0, bufferOffset);
                                bufferOffset = utils.writeVarInt(buffer, 0, bufferOffset);
                            }
                            bufferOffset = utils.writeVarInt(buffer, txOut.script.length, bufferOffset);
                            bufferOffset += txOut.script.copy(buffer, bufferOffset);
                        });
                        outputScriptHex = buffer.toString("hex");
                        associatedKeysets = txInfo.associatedDerivations.map(function (_a) {
                            var _b = __read(_a, 2), account = _b[0], index = _b[1];
                            return "".concat(fromAccount.params.path, "/").concat(fromAccount.params.index, "'/").concat(account, "/").concat(index);
                        });
                        inputs = txInfo.inputs.map(function (i) {
                            if (additionals && additionals.includes("peercoin")) {
                                // remove timestamp for new version of peercoin input, refer to https://github.com/peercoin/rfcs/issues/5 and https://github.com/LedgerHQ/ledgerjs/issues/701
                                var version = i.txHex.substring(0, 8);
                                hasTimestamp = version === "01000000" || version === "02000000";
                            }
                            (0, logs_1.log)("hw", "splitTransaction", {
                                transactionHex: i.txHex,
                                isSegwitSupported: true,
                                hasTimestamp: hasTimestamp,
                                hasExtraData: hasExtraData,
                                additionals: additionals
                            });
                            return [
                                btc.splitTransaction(i.txHex, true, hasTimestamp, hasExtraData, additionals),
                                i.output_index,
                                null,
                                i.sequence,
                            ];
                        });
                        lastOutputIndex = txInfo.outputs.length - 1;
                        (0, logs_1.log)("hw", "createPaymentTransactionNew", __assign(__assign(__assign(__assign(__assign(__assign(__assign({ inputs: inputs, associatedKeysets: associatedKeysets, outputScriptHex: outputScriptHex }, (params.lockTime && { lockTime: params.lockTime })), (params.sigHashType && { sigHashType: params.sigHashType })), (params.segwit && { segwit: params.segwit })), { initialTimestamp: initialTimestamp }), (params.expiryHeight && { expiryHeight: params.expiryHeight })), (((_a = txInfo.outputs[lastOutputIndex]) === null || _a === void 0 ? void 0 : _a.isChange) && {
                            changePath: "".concat(fromAccount.params.path, "/").concat(fromAccount.params.index, "'/").concat(txInfo.changeAddress.account, "/").concat(txInfo.changeAddress.index)
                        })), { additionals: additionals || [] }));
                        return [4 /*yield*/, btc.createPaymentTransactionNew(__assign(__assign(__assign(__assign(__assign(__assign(__assign({ inputs: inputs, associatedKeysets: associatedKeysets, outputScriptHex: outputScriptHex }, (params.lockTime && { lockTime: params.lockTime })), (params.sigHashType && { sigHashType: params.sigHashType })), (params.segwit && { segwit: params.segwit })), { initialTimestamp: initialTimestamp }), (params.expiryHeight && { expiryHeight: params.expiryHeight })), (((_b = txInfo.outputs[lastOutputIndex]) === null || _b === void 0 ? void 0 : _b.isChange) && {
                                changePath: "".concat(fromAccount.params.path, "/").concat(fromAccount.params.index, "'/").concat(txInfo.changeAddress.account, "/").concat(txInfo.changeAddress.index)
                            })), { additionals: additionals || [], onDeviceSignatureRequested: onDeviceSignatureRequested, onDeviceSignatureGranted: onDeviceSignatureGranted, onDeviceStreaming: onDeviceStreaming }))];
                    case 1:
                        tx = _c.sent();
                        return [2 /*return*/, tx];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.broadcastTx = function (fromAccount, tx) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fromAccount.xpub.broadcastTx(tx)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data.result];
                }
            });
        });
    };
    BitcoinLikeWallet.prototype.instantiateXpubFromSerializedAccount = function (account) {
        var _a;
        var crypto = (0, factory_1["default"])(account.params.currency);
        var storage = (_a = this.accountStorages)[account.params.storage].apply(_a, __spreadArray([], __read(account.params.storageParams), false));
        var explorer = this.getExplorer(account.params.explorer, account.params.explorerURI);
        return new xpub_1["default"]({
            storage: storage,
            explorer: explorer,
            crypto: crypto,
            xpub: account.xpub.xpub,
            derivationMode: account.params.derivationMode
        });
    };
    BitcoinLikeWallet.prototype.importFromSerializedAccount = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var xpub;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        xpub = this.instantiateXpubFromSerializedAccount(account);
                        return [4 /*yield*/, xpub.storage.load(account.xpub.data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, __assign(__assign({}, account), { xpub: xpub })];
                }
            });
        });
    };
    BitcoinLikeWallet.prototype.importFromSerializedAccountSync = function (account) {
        var xpub = this.instantiateXpubFromSerializedAccount(account);
        xpub.storage.loadSync(account.xpub.data);
        return __assign(__assign({}, account), { xpub: xpub });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.exportToSerializedAccount = function (account) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, account.xpub.storage["export"]()];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, account), { xpub: {
                                    xpub: account.xpub.xpub,
                                    data: data
                                } })];
                }
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    BitcoinLikeWallet.prototype.exportToSerializedAccountSync = function (account) {
        var data = account.xpub.storage.exportSync();
        return __assign(__assign({}, account), { xpub: {
                xpub: account.xpub.xpub,
                data: data
            } });
    };
    return BitcoinLikeWallet;
}());
exports["default"] = BitcoinLikeWallet;
//# sourceMappingURL=wallet.js.map